import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SignInScreen } from '@/features/auth/routes/sign-in-screen'

export const Route = createFileRoute('/sign-in')({
  // Where to go after signing in — set by the route guard when it bounces a
  // signed-out visitor, so they land back where they were heading.
  // `email-change` is where the link in an email-change confirmation lands.
  // Loose on purpose: when an AI app sends someone here, Better Auth's signed
  // OAuth parameters ride along, and dropping any of them breaks the signature.
  validateSearch: z.looseObject({
    redirect: z.string().optional(),
    'email-change': z.enum(['changed', 'expired', 'taken']).optional(),
  }),
  component: SignInScreen,
})
